import React, { useEffect, useRef, useState } from "react";
import "./CriarFabricanteEstaleiroModal.css";

const sanitizeTextInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeTextSave = (value, max = 80) => sanitizeTextInput(value, max).trim();

export default function CriarFabricanteEstaleiroModal({ open, onClose, onSalvar }) {
  const [fabricante, setFabricante] = useState("");
  const [modelo, setModelo] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const fabricanteRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setFabricante("");
    setModelo("");
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => fabricanteRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const fabricanteValue = sanitizeTextSave(fabricante);
      const modeloValue = sanitizeTextSave(modelo);
      if (!fabricanteValue) throw new Error("Informe o fabricante.");
      await onSalvar?.({ fabricante: fabricanteValue, modelo: modeloValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbecr-overlay" onClick={onClose}>
      <div className="fbecr-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Cadastrar fabricante">
        <div className="fbecr-head">
          <h3 className="fbecr-title">Cadastrar Fabricante</h3>
          <button className="fbecr-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="fbecr-body">
          <label className="fbecr-field">
            <span>Fabricante</span>
            <input
              ref={fabricanteRef}
              type="text"
              value={fabricante}
              onChange={(e) => setFabricante(sanitizeTextInput(e.target.value))}
              placeholder="Ex: NIPPON"
              autoComplete="off"
            />
          </label>
          <label className="fbecr-field">
            <span>Modelo (opcional)</span>
            <input
              type="text"
              value={modelo}
              onChange={(e) => setModelo(sanitizeTextInput(e.target.value))}
              placeholder="Ex: UIC 60"
              autoComplete="off"
            />
          </label>
          {err ? <div className="fbecr-error">{err}</div> : null}
        </div>

        <div className="fbecr-foot">
          <button className="fbecr-btn fbecr-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="fbecr-btn fbecr-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
